module.exports = __webpack_public_path__ + "b8ec1552242c3f8cf062a95c5f9cb8e2.pdf";